export default "__VITE_ASSET__CNaX5fkv__"